import { Pipe, PipeTransform } from '@angular/core';
import { RelivraisonStatut } from '../models/bon-livraison.model';

@Pipe({ name: 'formatRelivraisonStatut' })
export class FormatRelivraisonStatutPipe implements PipeTransform {
  transform(value: RelivraisonStatut): string {
    return this.format(value);
  }

  private format(statut: RelivraisonStatut): string {
    switch (statut) {
      case RelivraisonStatut.NA: return 'Non applicable';
      case RelivraisonStatut.ARelivrer: return 'À relivrer';
      case RelivraisonStatut.Conforme: return 'Conforme';
      case RelivraisonStatut.NonConforme: return 'Non conforme';
    }
    return status;
  }

}
